var _path, _path2, _g, _use, _use2, _use3, _use4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "flag-icons-hn",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#18c3df",
    d: "M0 0h512v512H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 170.7h512v170.6H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c",
    fill: "#18c3df",
    transform: "translate(256 256) scale(28.44446)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "m0-1-.3 1 .5.1z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    width: "100%",
    height: "100%",
    transform: "scale(-1 1)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    width: "100%",
    height: "100%",
    transform: "rotate(72)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    width: "100%",
    height: "100%",
    transform: "rotate(-72)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    width: "100%",
    height: "100%",
    transform: "rotate(144)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    width: "100%",
    height: "100%",
    transform: "rotate(-144)"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    width: "100%",
    height: "100%",
    transform: "translate(142.2 -45.5)"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    width: "100%",
    height: "100%",
    transform: "translate(142.2 39.8)"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    width: "100%",
    height: "100%",
    transform: "translate(-142.2 -45.5)"
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    width: "100%",
    height: "100%",
    transform: "translate(-142.2 39.8)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHn);
export default __webpack_public_path__ + "static/media/hn.f2196ae252ed7286c03ca58f4d8437b1.svg";
export { ForwardRef as ReactComponent };